import { FEATURES, WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { isFeatureVisible } from '../../capabilities/selector';
import type { WorkflowRule } from '../types';

// Standard mode: passed validation — redirect back to Sales View (external).
// Mirrors the VALID rule in shared-bff-utils/showroomApplicationState.ts: standardInvalidRule has
// already claimed the blocked deals by this point, so Desking here means valid.
//
// The old "no edition resolved yet" guard is gone — it existed to avoid redirecting a user who opened a deal
// for a dealership they lack access to, and `isFeatureVisible` is fail-closed, so an unhydrated
// capabilities slice already reads as not-Desking.
export const standardValidRule: WorkflowRule = (state: any): WorkflowStatus | null =>
    isFeatureVisible(FEATURES.SALES_VIEW_REDIRECTION)(state ?? {}) ? WorkflowStatus.REDIRECT_TO_SALES_VIEW : null;
